import React from "react";  
import { SpanText } from "../../../library/cms/content-components";
import { PageBaseComponent } from "../../../library/cms/page-components";
import EditIcon from "../../../library/cms/edit-icon";
import InfoIcon from "../../../library/cms/info-icon";
import { MediaManagerController } from "../../../library/cms/media-manager";
import { H2Title } from "../../../library/cms/content-components";
import { MinimalRichEditor } from "../../../library/cms/editor";
import { FairfieldButtonLink } from "../components/button-link";

export class TitlesGridComponent extends PageBaseComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onFile1Selected = (files) => {
        this.state.component.content.image1 = files[0];
        this.setState(this.state.component);
    }

    onFile2Selected = (files) => {
        this.state.component.content.image2 = files[0];
        this.setState(this.state.component);
    }

    onFile3Selected = (files) => {
        this.state.component.content.image3 = files[0];
        this.setState(this.state.component);
    }

    onFileCancel = () => {
    }

    onTitle1Change = (text) => {
        this.state.component.content.title1 = text;
        this.setState(this.state.component);
    }

    onTitle2Change = (text) => {
        this.state.component.content.title2 = text;
        this.setState(this.state.component);
    }

    onTitle3Change = (text) => {
        this.state.component.content.title3 = text;
        this.setState(this.state.component);
    }

    onCaption1Change = (text) => {
        this.state.component.content.caption1 = text;
        this.setState(this.state.component);
    }

    onCaption2Change = (text) => {
        this.state.component.content.caption2 = text;
        this.setState(this.state.component);
    }

    onCaption3Change = (text) => {
        this.state.component.content.caption3 = text;
        this.setState(this.state.component);
    }

    onEditClick1 = (event) => {
        this.mediaController1.mode = 'select';
        this.mediaController1.show([this.state.component.content.image1]);
    }

    onEditClick2 = (event) => {
        this.mediaController2.mode = 'select';
        this.mediaController2.show([this.state.component.content.image2]);
    }

    onEditClick3 = (event) => {
        this.mediaController3.mode = 'select';
        this.mediaController3.show([this.state.component.content.image3]);
    }

    onGetContent(data) {
        var content = {
            image1: this.state.component.content.image1,
            image2: this.state.component.content.image2,
            image3: this.state.component.content.image3,
            title1: this.state.component.content.title1,
            title2: this.state.component.content.title2,
            title3: this.state.component.content.title3,
            caption1: this.state.component.content.caption1,
            caption2: this.state.component.content.caption2,
            caption3: this.state.component.content.caption3
        }
        var data = {
            key: this.props.contentKey,
            content: content
        };
        return data;
    }


    render() {
        let state=this.state;
        let content = state.component.content;
        let active=state.component.active;
        let postUrl = '/api/MediaFile';
        let href1 = content.image1.link ? content.image1.link : '#';
        let href2 = content.image2.link ? content.image2.link : '#';
        let href3 = content.image3.link ? content.image3.link : '#';
        if(active){
            href1 = null;
            href2 = null;
            href3 = null;
        }
        return (
            <div className="titles-grid">
                <a className="title-section no-hover" href={href1}>
                    <SpanText active={active} cls="title-header" text={content.title1} onChange={this.onTitle1Change}  />
                    <div className="relative">
                        <div className="image-filter-2"><img src={content.image1.url} alt={content.title1} /></div>
                        <EditIcon onClick={this.onEditClick1} active={active}>
                            <MediaManagerController
                                postUrl={postUrl}
                                data={this.props.mediaManagerData}
                                ref={(ref) => this.mediaController1 = ref}
                                onFilesSelected={this.onFile1Selected}
                                onCancel={this.onFileCancel}
                            />
                        </EditIcon>
                        {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader}/>}
                    </div>
                   
                    <SpanText active={active} cls="title-caption" text={content.caption1} onChange={this.onCaption1Change}  />
                </a>
                <a className="title-section no-hover" href={href2}>
                    <SpanText active={active} cls="title-header" text={content.title2} onChange={this.onTitle2Change}  />
                    <div className="relative">
                        <div className="image-filter-2"><img src={content.image2.url} alt={content.title2} /></div>
                        <EditIcon onClick={this.onEditClick2} active={active}>
                            <MediaManagerController
                                postUrl={postUrl}
                                data={this.props.mediaManagerData}
                                ref={(ref) => this.mediaController2 = ref}
                                onFilesSelected={this.onFile2Selected}
                                onCancel={this.onFileCancel}
                            />
                        </EditIcon>
                        {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader}/>}
                    </div>
                    <SpanText active={active} cls="title-caption" text={content.caption2} onChange={this.onCaption2Change}  />
                     
                </a>
                <a className="title-section no-hover" href={href3}>
                    <SpanText active={active} cls="title-header" text={content.title3} onChange={this.onTitle3Change}  />
                    <div className="relative">
                        <div className="image-filter-2"><img src={content.image3.url} alt={content.title3} /></div>
                        <EditIcon onClick={this.onEditClick3} active={active}>
                            <MediaManagerController
                                postUrl={postUrl}
                                data={this.props.mediaManagerData}
                                ref={(ref) => this.mediaController3 = ref}
                                onFilesSelected={this.onFile3Selected}
                                onCancel={this.onFileCancel}
                            />
                        </EditIcon>
                        {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader}/>}
                    </div>  
                    <SpanText active={active} cls="title-caption" text={content.caption3} onChange={this.onCaption3Change}  />
                </a>
            </div>
        );
    }
}

export class TradeGridComponent extends PageBaseComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onFileSelected = (files) => {
        this.state.component.content.image = files[0];
        this.setState(this.state.component);
    }

    onFileCancel = () => {
    }

    onEditClick = (event) => {
        this.mediaController.mode = 'select';
        this.mediaController.show([this.state.component.content.image]);
    }

    onSave=(link,label)=>{
        this.state.component.content.buttonLink=link;
        this.state.component.content.buttonLabel=label;
        this.setState(this.state.component);
    }

    onGetContent(data) {
        var content = {
            title: this.state.component.content.title,
            image: this.state.component.content.image,
            html: this.editor.getContent(),
            buttonLink: this.state.component.content.buttonLink,
            buttonLabel: this.state.component.content.buttonLabel
        }
        var data = {
            key: this.props.contentKey,
            content: content
        };
        return data;
    }

    render() {
        let state=this.state;
        let content = state.component.content;
        let active=state.component.active;
        let postUrl = '/api/MediaFile';
        return (
            <div className="trade-grid">
                <div className="relative">
                    <div className="trade-image image-filter-2">
                        <img src={content.image.url} alt={content.image.title} />
                        <EditIcon onClick={this.onEditClick} active={active}>
                            <MediaManagerController
                                postUrl={postUrl}
                                data={this.props.mediaManagerData}
                                ref={(ref) => this.mediaController = ref}
                                onFilesSelected={this.onFileSelected}
                                onCancel={this.onFileCancel}
                            />
                        </EditIcon>
                        {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader}/>}
                    </div>
                </div>
               
                <div className="trade-content">
                    <H2Title active={active} cls="trade-title" title={content.title} onChange={(text)=>{content.title=text; this.setState(state)}}  />
                    <MinimalRichEditor 
                        content={content.html} 
                        active={active} 
                        disableSticky={true} 
                        addColors='#8f8f8f,#666666' 
                        ref={(ref) => this.editor = ref} 
                    /> 
                    <FairfieldButtonLink 
                        active={active} 
                        link={content.buttonLink} 
                        label={content.buttonLabel} 
                        onSave={this.onSave}
                        buttonCss="ui-button-default margin-top two"
                    />
                   
                </div>
            </div>

        );
    }
}

export class WoodFinishesComponent extends PageBaseComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onFileSelected = (files) => {
        this.state.component.content.image = files[0];
        this.setState(this.state.component);
    }

    onFileCancel = () => {
    }

    onTitleChange = (text) => {
        this.state.component.content.title = text;
        this.setState(this.state.component);
    }

    onEditClick = (event) => {
        this.mediaController.mode = 'select';
        this.mediaController.show([this.state.component.content.image]);
    }

    onSave = (link, label) => {
        this.state.component.content.buttonLink = link;
        this.state.component.content.buttonLabel = label;
        this.setState(this.state.component);
    }

    onGetContent(data) {
        var content = {
            image: this.state.component.content.image,
            title: this.state.component.content.title,      
            html: this.editor.getContent(),
            buttonLink: this.state.component.content.buttonLink,
            buttonLabel: this.state.component.content.buttonLabel
        }
        var data = {
            key: this.props.contentKey,
            content: content
        };
        return data;
    }

    render() {
        let state=this.state;
        let content = state.component.content;
        let active=state.component.active;
        let postUrl = '/api/MediaFile';  
        return(
            <div className="finishes-inner-container">
                <SpanText active={active} cls="finishes-title" text={content.title} onChange={this.onTitleChange} />
                <div className="finishes-grid">
                    <div className="finishes-content">
                        <MinimalRichEditor 
                            content={content.html} 
                            active={active} 
                            disableSticky={true} 
                            addColors='#8f8f8f,#666666' 
                            ref={(ref) => this.editor = ref} 
                        /> 
                        <FairfieldButtonLink 
                            active={active} 
                            link={content.buttonLink} 
                            label={content.buttonLabel} 
                            onSave={this.onSave}
                            buttonCss="ui-button-default margin-top two"
                        />  
                    </div>
                    <div className="finishes-image relative">
                        <img src={content.image.url} alt={content.image.title} className="image-filter-1" />
                        <EditIcon onClick={this.onEditClick} active={active}>
                            <MediaManagerController
                                postUrl={postUrl}
                                data={this.props.mediaManagerData}
                                ref={(ref) => this.mediaController = ref}
                                onFilesSelected={this.onFileSelected}
                                onCancel={this.onFileCancel}
                            />
                        </EditIcon>
                        {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
                    </div>
                </div>
            </div>
        );
    }

}


export default {TitlesGridComponent, TradeGridComponent,WoodFinishesComponent};